// Single source of truth for "which video is currently unmuted." When a
// user unmutes one video, every other VideoPlayer that's subscribed mutes
// itself. Module-level state (not Redux) so the coordinator is cheap, has
// no render churn, and works for unmounted players too (their subscription
// just no-ops since they cleaned up on unmount).

let currentId = null;
const subscribers = new Set();

export function setUnmutedId(id) {
  currentId = id;
  subscribers.forEach((cb) => cb(id));
}

export function getUnmutedId() {
  return currentId;
}

export function subscribeUnmuted(cb) {
  subscribers.add(cb);
  return () => {
    subscribers.delete(cb);
  };
}

// Stable, collision-resistant id factory for VideoPlayer instances. The
// id is opaque — we only ever compare for equality with `getUnmutedId()`.
let counter = 0;
export function nextVideoId() {
  counter += 1;
  return `vp-${counter}`;
}
